import React from "react";
import { getPlatform } from "../../utils/config";
import { ANDRIOD_URL, IOS_URL } from "../../utils/constants";
import { getAssetUrl, openExternalLinkInNewTab } from "../../utils/common";
import {
  Body3RegularTypography,
  BottomSheet,
  Button,
  FlexColumn,
  Heading2SemiboldTypography,
  StyledImage,
} from "@wish-ui";

export const AppForceUpdate = ({
  open = false,
  title = "Attention Creators!!",
  description = "To ensure seamless performance and continued access to all features, update your app now!",
}) => {
  const platform = getPlatform();

  if (!open || platform === "web") return <></>;

  const redirectUrl = platform === "ios" ? IOS_URL : ANDRIOD_URL;

  return (
    <BottomSheet open handleClose={() => {}}>
      <FlexColumn pt={10} gap={20} alignItems="center" justifyContent="center">
        <StyledImage
          src={getAssetUrl("UpdateCentral.png")}
          width={140}
          height={145}
        />
        <FlexColumn gap={8} alignItems="center" justifyContent="center">
          <Heading2SemiboldTypography fontFamily="Lexend" textAlign="center">
            {title}
          </Heading2SemiboldTypography>
          <Body3RegularTypography textAlign="center">
            {description}
          </Body3RegularTypography>
        </FlexColumn>
        <Button
          variant="primary"
          onClick={() => openExternalLinkInNewTab({ redirectUrl })}
        >
          Update Now
        </Button>
      </FlexColumn>
    </BottomSheet>
  );
};
